// extracted by mini-css-extract-plugin
export default {"root":"UserName_root__Emncf","container":"UserName_container__-yXjo","box":"UserName_box__lduFM","circle":"UserName_circle__IYyLK","name":"UserName_name__O3R0+"};